export default {
  privacyPolicy:
    'https://docs.google.com/document/d/e/2PACX-1vS3104tnY1jm1iMdMLpqkDbbJhYncNTM5DQWDY6K6TzUyYNGZgXsrLAMHiZvaIzinamZwFg_Z9NZYmw/pub',
  termsOfService:
    'https://docs.google.com/document/d/e/2PACX-1vTpcYHv9cDrQlmImpH6lWTXeZXOoafKZfweq30HD4zQMYaKYJsYybkZ-KkOg6fr_j9ZX50GFOvFaZag/pub',
  version: '1.20.4',
};
